import React from 'react'
import PropTypes from 'prop-types'
import ComingSoonOverlay from '../ComingSoonOverlay/ComingSoonOverlay'
import styles from './MockedPanel.module.scss'

export default function MockedPanel({ children, gap = null, overlay = undefined }) {
  return (
    <div className="position-relative">
      <div className={styles.content} aria-hidden="true" inert="">
        {children}
      </div>
      {overlay ?? <ComingSoonOverlay gap={gap} />}
    </div>
  )
}

MockedPanel.propTypes = {
  children: PropTypes.node.isRequired,
  gap: PropTypes.shape({ reason: PropTypes.string }),
  overlay: PropTypes.node,
}
